<template>
  <div class="empty-layout-container" :style="styles">
    <div class="background-shape" />
    <div class="background-shape-2" />
    <div class="content">
      <router-view />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { HexToRGB } from '@/utils-ts'
  import { computed } from 'vue'

  const styles = computed(() => {
    const brandColorRGB = HexToRGB('#8C3C84')
    const textColorRGB = HexToRGB('#8C3C84')
    const sidebarColorRGB = HexToRGB('#FFFFFF')
    return {
      '--brand-color': '#8C3C84',
      '--brand-color-rgb': `${brandColorRGB?.r}, ${brandColorRGB?.g}, ${brandColorRGB?.b}`,

      '--text-color': '#8C3C84',
      '--text-color-rgb': `${textColorRGB?.r}, ${textColorRGB?.g}, ${textColorRGB?.b}`,

      '--sidebar-color': '#FFFFFF',
      '--sidebar-color-rgb': `${sidebarColorRGB?.r}, ${sidebarColorRGB?.g}, ${sidebarColorRGB?.b}`,
    }
  })
</script>

<style lang="scss" scoped>
  .empty-layout-container {
    @include flexible($align: center, $justify: center);
    min-height: 100vh;
    max-height: 100vh;
    max-width: 100vw;
    position: relative;
    background-color: rgb(252, 241, 241);
    background-image: radial-gradient(#d1d5db 1px, transparent 1px);
    background-size: 20px 20px;
    overflow: hidden;

    .background-shape {
      position: absolute;
      bottom: -40vh;
      right: 0;
      width: 100%;
      height: 80vh;
      transform: rotate(-15deg);
      background: linear-gradient(135deg, #e24d07, #8c3c84);
      z-index: 0;
      border-top-left-radius: 300px 150px;
      border-top-right-radius: 500px 250px;

      @include media(xs, sm, md) {
        height: 50vh;
        bottom: -20vh;
        border-top-left-radius: 150px 100px;
        border-top-right-radius: 250px 150px;
      }
    }

    .background-shape-2 {
      position: absolute;
      top: -15vh;
      left: 0;
      width: 40vw;
      height: 60vh;
      transform: rotate(-15deg);
      background: linear-gradient(135deg, #e24d07, #8c3c84);
      z-index: 0;
      border-bottom-right-radius: 300px;
      border-bottom-left-radius: 500px;

      @include media(xs, sm, md) {
        width: 70vw;
        height: 40vh;
        top: -10vh;
        border-bottom-right-radius: 150px;
        border-bottom-left-radius: 200px;
      }
    }

    .content {
      @include flexible($align: center, $justify: center);
      width: 100%;
      z-index: 10;
    }
  }
</style>
